import { CATEGORY } from '../utils/APIUtil';
import axios from 'axios';
import AuthService from './auth/AuthService';

const Auth = new AuthService();
export default class OrderService {
  constructor() {
    this.fetch = this.fetch.bind(this);
  }

  async getCategoryList() {
    const res = await this.fetch(CATEGORY, {
      method: 'GET',
    });
    return Promise.resolve(res);
  }

  async getCategoryById(id) {
    const res = await this.fetch(CATEGORY + '/' + id, {
      method: 'GET',
    });
    return Promise.resolve(res);
  }

  async addCategory(jsonData) {
    const response = await axios.post(CATEGORY, jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.success) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  async deleteCategoryById(id) {
    const response = await axios.delete(CATEGORY + '/' + id, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response.error);
    }
  }

  async updateCategory(jsonData, id) {
    const response = await axios.put(CATEGORY + '/' + id, jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.success) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  async addIcon(formData, id) {
    const response = await axios.post(CATEGORY + '/icon/' + id, formData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.result === 'OK') {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  fetch(url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      'Accept': 'application/json',
    };
    headers['Authorization'] = 'Bearer ' + Auth.getToken();
    return fetch(url, {
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then(response => response.json());
  }

  _checkStatus(response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }
}
